import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { TEltFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { isDocType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/isDocType'

import { IChangedSteps } from '../../models/IChangedSteps'

import { stepsContents, stepsDocContents } from './config'
import { hasChanges } from './hasChanges'

interface IGetChangedDataBySteps {
  initialData: TEltFormData
  dataForSave: TEltFormData
  eltType: EltType
}

export const getChangedSteps = ({
  initialData,
  dataForSave,
  eltType,
}: IGetChangedDataBySteps): IChangedSteps => {
  const steps = isDocType(eltType) ? stepsDocContents : stepsContents
  return Object.entries(steps).reduce((acc, [step, stepContent]) => {
    return {
      ...acc,
      [step]: hasChanges({ initialData, dataForSave, stepContent }),
    } as IChangedSteps
  }, {} as IChangedSteps)
}
